export default __webpack_public_path__ + "static/media/genuine-additional2.77653fa2.png";